// Entry point: loads the WASM module, then shows the start page, joins `?lobby=CODE` or starts `?offline`.
import init, { constants } from '../pkg/client_wasm.js';
import { listenInput } from './input.js';
import { showMenu } from './menu.js';
import { startOffline } from './offline.js';
import { startOnline } from './online.js';
import { applyTheme } from './theme.js';
import type { Constants } from './render.js';

const status = document.getElementById('status')!;
const canvas = document.getElementById('game') as HTMLCanvasElement;
const ctx = canvas.getContext('2d')!;
applyTheme();

async function start(): Promise<void> {
  await init({ module_or_path: 'client_wasm_bg.wasm' });
  const [
    tickRate,
    tankRadius,
    bulletRadius,
    barrelLength,
    tankStride,
    bulletStride,
    blastStride,
    pickupStride,
    markStride,
    pickupRadius,
    mineRadius,
    spotStride,
    holeRadius,
    droneSide,
    smokeRadius,
  ] = constants();
  const consts: Constants = {
    tankRadius,
    bulletRadius,
    barrelLength,
    tankStride,
    bulletStride,
    blastStride,
    pickupStride,
    markStride,
    pickupRadius,
    mineRadius,
    spotStride,
    holeRadius,
    droneSide,
    smokeRadius,
  };

  listenInput();
  const params = new URLSearchParams(location.search);
  const lobby = params.get('lobby');
  const online = (code: string) => startOnline(ctx, status, consts, 1 / tickRate, code);
  if (params.has('offline')) {
    startOffline(ctx, status, consts, 1 / tickRate);
  } else if (lobby) {
    online(lobby.trim().toUpperCase());
  } else {
    showMenu(status, online, consts);
  }
}

start().catch((e) => {
  status.textContent = `Error: ${e}`;
  console.error(e);
});
